var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "theme-previewer-lib": "static-1.52431"
    },
    "depPathPrefixes": {
      "theme-previewer-lib": "/theme-previewer-lib/static-1.52431"
    },
    "project": "theme-previewer-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};